export default __webpack_public_path__ + "static/media/benefits-background.8c912b9c.png";